import styles from "./quizSuccess.module.css";
import { useNavigate } from "react-router-dom";

export default function QuizSuccess({ quizData, correctAnswersCount }) {
  const quizObject = quizData.data;
  const questionsArray = quizObject.questions;
  const navigate = useNavigate();
  const total = questionsArray.length;
  const percentage = Math.round((correctAnswersCount / total) * 100);
  const message = percentage >= 80 ? "Excellent work!" : percentage >= 50 ? "Good progress!" : "Keep learning—you've got this.";

  return (
    <>
      <div className={styles.successPage_container}>
        <div className={styles.successPage_content}>
          <div className={styles.statusIcon} aria-hidden="true">✓</div>
          <p className={styles.eyebrow}>QUIZ COMPLETE</p>
          <h1 className={styles.sucessMsg}>{message}</h1>
          <p className={styles.resultCopy}>You answered {correctAnswersCount} of {total} questions correctly.</p>
          <div className={styles.scoreRing} style={{"--score": `${percentage * 3.6}deg`}} aria-label={`Score ${percentage} percent`}><div><strong>{percentage}%</strong><span>Your score</span></div></div>
          <div className={styles.stats}><div><strong>{correctAnswersCount}</strong><span>Correct</span></div><div><strong>{total - correctAnswersCount}</strong><span>Incorrect</span></div><div><strong>{total}</strong><span>Total</span></div></div>
          <div className={styles.actions}><button onClick={() => window.location.reload()}>Try again</button><button className={styles.secondary} onClick={() => navigate("/")}>Back to home</button></div>
        </div>
      </div>
    </>
  );
}
